import {
    CLEAN_ALL,
    GETRECENTBUY,
    SETTOKEN,
    SETUSER,
    SETUSERDETAIL,
    INITUSERDETAIL,
    CONNECT_WALLET,
    SETHISTORY,
    CLEARHISTORY,
    INITCONFIG
} from './mutations-types.js'
import { Toast } from "vant";
import i18n from '../lang/lang.js'
// import { getuserdetail } from '../service/getdata';
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}
export default {

    //清理所有本地存储
    [CLEAN_ALL](stat) {
        window.localStorage.clear();
    },
    [SETTOKEN](state, token) {
        if (token) {
            state.token = token;
            setStore('token', state.token);
        } else {
            var token_ = getStore('token');
            state.token = token_
        }
    },
    [SETUSER](state, userifo) {
        if (userifo) {
            state.user = userifo;
            setStore('userifo', state.user);
        } else {
            var userinfo_ = JSON.parse(getStore('userifo'));
            state.user = userinfo_
        }
    },
    [SETUSERDETAIL](state, token) {
        getuserdetail(token).then(function(res) {
            var res = res.data;
            if (res.Code == "0") {
                state.userdetail = res.Data;
                setStore('userdetail', state.userdetail);
            } else {
                alert("获取用户信息失败，请稍后重新登录")
            }
        })
    },
    [INITUSERDETAIL](state) {
        var userdetail = JSON.parse(getStore('userdetail'));
        state.userdetail = userdetail
    },
    INITPOLICYDETAIL(state, detail) {
        if (detail) {
            state.policydetail = detail;
            setStore('policydetail', state.policydetail);
        } else {
            var policydetail = JSON.parse(getStore('policydetail'));
            state.policydetail = policydetail
        }
    },
    SETHISTORY(state, history) {
        if (history) {
            var hdata = JSON.stringify(state.s_history);
            if (hdata.indexOf(history.ticker) == -1) {
                state.s_history.push(history);
            }
            setStore('history', state.s_history);
        } else {
            var history = JSON.parse(getStore('history')) || [];
            state.s_history = history;
        }
    },

    async [CONNECT_WALLET](state) {
        Toast.loading({duration: 0, forbidClick: true})
        setTimeout(async () => {
          const eth = window.ethereum
          if (eth) { // 钱包环境
            const accounts = await eth.request({ method: "eth_requestAccounts" }).catch(err => {
              const { code } = err
              if (code === 4001) {
                Toast.fail(i18n.t('您拒绝了链接'))
                return
              }
            })
            if (accounts) {
            //   await dispatch(GET_USERINFO, accounts)
                state.user = accounts[0];
                setStore('userifo', state.user);
              Toast.success(i18n.t('连接钱包成功'))
              eth.on('accountsChanged', async (accounts) => { // 登录变了
                commit(SET_OUT)
                if (!accounts.length) {
                  Toast.fail(i18n.t('已断开钱包'))
                } else { // 重新请求数据
                //   await dispatch(GET_USERINFO, accounts)
                //   const data = await _checkStatus()
                //   commit(SET_STATUS, data.status)
                  Toast.success(i18n.t('钱包切换成功'))
                }
              })
            } else {
              // Toast('连接钱包异常')
            }
          } else {
            Toast.fail(i18n.t('请先安装钱包插件'))
          }
        }, 300);
    },
    CLEARHISTORY(state) {
        state.s_history = []
    },
    INITCONFIG(state, config) {
        if (config) {
            state.config = config;
            setStore("config", config)
        } else {
            state.config = config || ""
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js